import { Box, ButtonBase, Grid2, Typography } from "@mui/material";
import { getDate, isSameMonth, isToday } from "date-fns";
import { JSX } from "react";
import { Link, To } from "react-router";

type ContentProps = {
    day: Date;
    firstOfMonth: Date;
    renderDay: (day: Date, isActive: boolean) => JSX.Element;
};

function Content({ day, firstOfMonth, renderDay }: ContentProps) {
    const isCurrentDay = isToday(day);
    return (
        <Box width={1} height={1} p={1}>
            <Typography
                variant="h5"
                width="100%"
                align="right"
                sx={{
                    backgroundColor: isCurrentDay ? theme => theme.palette.primary.main : "transparent",
                    color: isCurrentDay ? theme => theme.palette.primary.contrastText : "inherit",
                    borderRadius: isCurrentDay ? "50%" : 0,
                    width: isCurrentDay ? 32 : "auto",
                    height: isCurrentDay ? 32 : "auto",
                    margin: isCurrentDay ? "auto" : undefined,
                    alignItems: "center",
                    justifyContent: "center",
                    display: "flex",
                }}
            >
                {getDate(day)}
            </Typography>
            {renderDay(day, isSameMonth(day, firstOfMonth))}
        </Box>
    );
}

type Props = {
    day: Date;
    firstOfMonth: Date;
    url?: To;
    onDateClicked?: (day: Date) => void;
    renderDay: (day: Date, isActive: boolean) => JSX.Element;
};

export default function CalendarDayPlan({ day, firstOfMonth, url, onDateClicked, renderDay }: Props) {
    return (
        <Grid2 size={1} key={day.toISOString()}>
            {onDateClicked || url ? (
                <ButtonBase
                    onClick={() => onDateClicked?.(day)}
                    disabled={!onDateClicked && !url}
                    sx={{ width: 1, height: 1 }}
                    component={Link}
                    to={url || ""}
                >
                    <Content day={day} firstOfMonth={firstOfMonth} renderDay={renderDay} />
                </ButtonBase>
            ) : (
                <Content day={day} firstOfMonth={firstOfMonth} renderDay={renderDay} />
            )}
        </Grid2>
    );
}
